import config from '__api/config';
import { getBulletRwdList } from '__api/dsbc/inv/getBulletRwdList';
import { Spacer } from 'emrn-design/Spacer';
import { rpx } from 'emrn-design/rpx';
import React, { Component } from 'react';
import { Text, View, Animated, Easing, StyleSheet, Platform } from 'react-native';

export interface scroolItem {
  tab: string;
  title: string;
  jumpUrl: string;
  status?: number;
}
interface ScrollVerticalProps {}
interface ScrollVerticalStates {
  translateValue: Animated.ValueXY;
  // 滚屏高度
  scrollHeight: number;
  // 滚屏内容
  kb_content: any;
  // Animated.View 滚动到的 y轴坐标
  kb_tempValue: number;
  // 最大偏移量
  kb_contentOffsetY: number;
  // 每一次滚动切换之前延迟的时间
  delay: number;
  // 每一次滚动切换的持续时间
  duration: number;
  scrollSwipeData: string[];
}
export class ScrollVertical extends Component<ScrollVerticalProps, ScrollVerticalStates> {
  private animation: any;
  private i = 0;
  constructor(props: ScrollVerticalProps) {
    super(props);
    this.state = {
      scrollSwipeData: [],
      translateValue: new Animated.ValueXY({ x: 0, y: 0 }),
      // 滚屏高度
      scrollHeight: rpx(30),
      // 滚屏内容
      kb_content: [],
      // Animated.View 滚动到的 y轴坐标
      kb_tempValue: 0,
      // 最大偏移量
      kb_contentOffsetY: 0,
      // 每一次滚动切换之前延迟的时间
      delay: 600,
      // 每一次滚动切换的持续时间
      duration: 600,
    };
    this.createKbItem = this.createKbItem.bind(this);
  }

  async componentDidMount() {}
  componentWillUnmount() {
    if (this.animation) {
      clearTimeout(this.animation);
    }
  }
  /**
   * 获取抽奖滚动信息数据
   * */
  _getBulletRwdList = async () => {
    const res = await getBulletRwdList({ invId: config.invId });
    if (res && res.IsSuccess) {
      this.setState({
        scrollSwipeData: res?.Data || [],
      });
    } else {
      return;
    }
  };
  onLayout = async () => {
    await this._getBulletRwdList();
    const content = this.state.scrollSwipeData || [];
    if (content.length !== 0) {
      const h = (content.length - 2) * this.state.scrollHeight;
      this.setState({
        kb_content: [...content],
        kb_contentOffsetY: h,
      });
      // 开始动画
      this.startAnimation();
    }
  };
  createKbItem(kbItem: scroolItem, index: number) {
    return (
      <>
        <View
          style={{
            justifyContent: 'center',
            height: rpx(25),
            alignItems: 'center',
            borderRadius: rpx(24),
            backgroundColor: 'rgba(51,51,51,0.6)',
          }}
          key={index}
        >
          <Text style={styles.text} numberOfLines={1}>
            {kbItem}
          </Text>
        </View>
        <Spacer size={rpx(5)} />
      </>
    );
  }
  startAnimation = () => {
    if (!this.animation) {
      this.animation = setTimeout(() => {
        this.animation = null;
        this.startAnimationSeamless();
      }, this.state.delay);
    }
  };

  startAnimationSeamless = () => {
    const { kb_tempValue, scrollHeight, kb_contentOffsetY, translateValue, duration } = this.state;
    this.setState({
      kb_tempValue: kb_tempValue - scrollHeight,
    });

    Animated.sequence([
      Animated.timing(translateValue, {
        isInteraction: false,
        toValue: { x: 0, y: kb_tempValue },
        duration: duration, // 动画持续的时间（单位是毫秒），默认为500
        easing: Easing.linear,
        useNativeDriver: Platform.OS === 'web' ? false : true,
      }),
    ]).start(() => {
      // 无缝切换
      if (kb_tempValue <= -kb_contentOffsetY) {
        // 快速拉回到初始状态
        this.setState({
          kb_tempValue: 0,
          translateValue: new Animated.ValueXY({ x: 0, y: 0 }),
        });
      }
      this.startAnimation();
    });
  };

  render() {
    return (
      <View style={styles.kbContainer} onLayout={this.onLayout}>
        {this.state.kb_content.length !== 0 ? (
          <Animated.View
            style={[{ flexDirection: 'column' }, { transform: [{ translateY: this.state.translateValue.y }] }]}
          >
            {this.state.kb_content.map(this.createKbItem)}
          </Animated.View>
        ) : null}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  kbContainer: {
    // 必须要有一个背景或者一个border，否则本身高度将不起作用
    backgroundColor: 'transparent',
    overflow: 'hidden',
    height: rpx(58),
  },
  text: {
    fontSize: rpx(12),
    color: '#FFFFFF',
    paddingHorizontal: rpx(4),
  },
});
